import SidePhotosUploader from './SidePhotosUploader'
export default SidePhotosUploader
